import { RpcService } from './RpcService';

export class RpcServiceStub extends RpcService {
	public async invokeClient<T>(
		methodName: string,
		payload?: unknown,
	): Promise<T> {
		console.log('[RPC-client] ' + methodName, payload);
		return null as T;
	}

	public async invokeServer<T>(
		methodName: string,
		payload?: unknown,
	): Promise<T> {
		console.log('[RPC-server] ' + methodName, payload);
		return null as T;
	}

	public register<T>(methodName: string, callback: (payload: T) => void): void {
		if (!window.__rpc) {
			window.__rpc = {};
		}

		window.__rpc[methodName] = callback as (payload: unknown) => unknown;

		console.log('[RPC] Registered method ' + methodName);
	}

	public async callLocal(methodName: string, payload?: unknown): Promise<void> {
		const callback = window.__rpc?.[methodName];
		if (!callback) {
			throw new Error(`RPC with name "${methodName}" doesn't exist`);
		}

		await callback(payload);
	}
}
